import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface PorchDeckPatioProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const PorchDeckPatio: React.FC<PorchDeckPatioProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [porchDeckPatio, setPorchDeckPatio] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Exterior Features']?.['Porch, Deck, Patio'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Exterior Features': { ...s.values?.['Exterior Features'], 'Porch, Deck, Patio': v } } })
    );
    const label = 'Porch, Deck, Patio';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={porchDeckPatio}
                />
            ) : (
                <TextBox
                    value={porchDeckPatio ?? ''}
                    onChange={(value) => setPorchDeckPatio(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
